import styled from '@emotion/styled';
import { yellow } from '@mui/material/colors';
import grey from '@mui/material/colors/grey';
import { PANEL_TYPE } from '../pages/auth';
import { keyframes, css } from '@emotion/react';

const Wrapper = styled.div`
  margin : 100px auto;
  max-width : 400px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  box-sizing : border-box;
  padding : 29px 48px;
  border-radius : 8px;
  color : #2C444A;
  display : flex;
  flex-direction : column;
  
  transform : ${props => props.pendingRequest ? 'scaleY(0)' : 'scaleY(1)'};
  
  transition : background 0.4s ease-in, transform 0.3s 0.3s ease-in;
 
  h2 {
   text-align : center;
   font-size : 24px;
   
   transition : color 0.4s ease-in;
  }
  
  
`;

const FormBox = styled.div`
  min-height : ${props => props.minHeight ? props.minHeight : '100px'};
  display : flex;
  flex-direction : column;
  justify-content : space-between;
  margin : 12px 0px;
  user-select : none;
`;

const LoginButton = styled.div`
  width : 100%;
  height : 44px;
  display : flex;
  justify-content : center;
  align-items : center;
  background : ${yellow[700]};
  color : white;
  border-radius : 4px;
  margin-top : 40px;
  user-select : none;
  
  &:hover{
    background : ${yellow[800]};
  }
`;

const AdditionalOptions = styled.div`
  display : flex;
  justify-content : space-between;
  font-size : 11px;
  
  span {
    cursor : pointer;
    color : ${yellow[900]};
  }
  
  span:hover {
      text-decoration: underline;
  }
`;


const ActivePanel = styled.div`
  position : absolute;
  transform: ${props => props.panel === PANEL_TYPE.LOGIN ? 'translateX(0)' : 'translateX(-100%)'};
  left: ${props => props.panel === PANEL_TYPE.LOGIN ? '0' : '100%'};
  display : inline-block;
 
  width : 50%;
  user-select : none;
  line-height : 38px;
  border-radius : 4px;
  text-align : center;
  color : #fff;
  font-weight : 600;
  font-size : 13px;
  cursor : pointer;
  background : ${yellow[700]};
 
  transition : background 0.2s ease-in-out, transform 0.3s ease-in-out, left 0.3s ease-in-out, height 0.3s ease-in-out;
  
  &:hover{
   background : ${yellow[800]};
  }
`;

const ButtonsWrapper = styled.div`
  border : 1px solid ${grey[300]}; 
  border-radius : 4px; 
  margin-bottom : 30px;
  position : relative;
  display : flex;
  align-items : center;
`;

const PanelToggle = styled.div`
  display : inline-block;
  height : 38px;
  width : 50%;
    user-select : none;
  line-height : 38px;
  border-radius : 4px;
  text-align : center;
  color : ${props => props.active ? '#fff' : grey[900]};
  font-weight : 600;
  font-size : 13px;
  cursor : pointer;
  background : ${props => props.active ? yellow[700] : '#fff'};
  
  transition : background 0.2s ease-in-out;
  
  &:hover{
   background : ${props => props.active ? yellow[800] : grey[200]};
  }
`;

export {
  PanelToggle,
  AdditionalOptions,
  LoginButton,
  FormBox,
  Wrapper,
  ActivePanel,
  ButtonsWrapper
}